import { render, staticRenderFns } from "./zhzx.vue?vue&type=template&id=f1517336"
import script from "./zhzx.vue?vue&type=script&lang=js"
export * from "./zhzx.vue?vue&type=script&lang=js"
import style0 from "./zhzx.vue?vue&type=style&index=0&id=f1517336&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports